var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _dec44, _dec45, _dec46, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20, _descriptor21, _descriptor22, _descriptor23, _descriptor24, _descriptor25, _descriptor26, _descriptor27, _descriptor28, _descriptor29, _descriptor30, _descriptor31, _descriptor32, _descriptor33, _descriptor34, _descriptor35, _descriptor36, _descriptor37, _descriptor38, _descriptor39, _descriptor40, _descriptor41, _descriptor42, _descriptor43, _descriptor44, _descriptor45, _descriptor46, _class2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import { array, fragment, fragmentArray } from 'ember-data-model-fragments/attributes';
import { CatalogItemProductType as CatalogItemProductTypeProto, EcomVisibility as EcomVisibilityProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/enums';
import CatalogFragment from '@square/dashboard-items-data/models/connect/catalog-fragment';
export let EcomVisibility = /*#__PURE__*/function (EcomVisibility) {
  EcomVisibility["DO_NOT_USE"] = "DO_NOT_USE";
  EcomVisibility["UNINDEXED"] = "UNINDEXED";
  EcomVisibility["UNAVAILABLE"] = "UNAVAILABLE";
  EcomVisibility["HIDDEN"] = "HIDDEN";
  EcomVisibility["VISIBLE"] = "VISIBLE";
  return EcomVisibility;
}({});
let Data = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('boolean', {
  allowNull: true
}), _dec6 = attr('boolean', {
  allowNull: true
}), _dec7 = attr('boolean', {
  allowNull: true
}), _dec8 = attr('boolean', {
  allowNull: true
}), _dec9 = attr('string'), _dec10 = attr('string'), _dec11 = attr('number'), _dec12 = fragmentArray('connect/item/modifier-list-info'), _dec13 = attr('string'), _dec14 = attr('string', {
  protoEnum: CatalogItemProductTypeProto
}), _dec15 = attr('boolean', {
  allowNull: true,
  defaultValue: false
}), _dec16 = attr('boolean', {
  allowNull: true,
  defaultValue: false
}), _dec17 = array(), _dec18 = attr('string'), _dec19 = array(), _dec20 = attr('boolean', {
  allowNull: true
}), _dec21 = attr('string'), _dec22 = attr('string'), _dec23 = attr('string', {
  protoEnum: EcomVisibilityProto
}), _dec24 = array(), _dec25 = array(), _dec26 = attr('string'), _dec27 = fragmentArray('connect/category/membership'), _dec28 = fragment('connect/category/membership'), _dec29 = fragment('connect/ecom-seo-data'), _dec30 = fragment('connect/open-graph-data'), _dec31 = attr('string'), _dec32 = attr('string'), _dec33 = attr('string'), _dec34 = array(), _dec35 = attr('boolean', {
  allowNull: true
}), _dec36 = attr('number', {
  allowNull: true
}), _dec37 = attr('boolean', {
  allowNull: true,
  defaultValue: false
}), _dec38 = attr('boolean', {
  allowNull: true,
  defaultValue: false
}), _dec39 = attr('string'), _dec40 = attr('boolean', {
  allowNull: true
}), _dec41 = attr('string', {
  allowNull: true
}), _dec42 = fragment('connect/item/food-and-beverage-details'), _dec43 = fragment('connect/item/combo-type-details'), _dec44 = fragmentArray('connect/item/item-location-override'), _dec45 = fragmentArray('connect/channel-integrations'), _dec46 = fragmentArray('connect/program-eligibility'), _class = (_class2 = class Data extends CatalogFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "description", _descriptor2, this);
    _initializerDefineProperty(this, "abbreviation", _descriptor3, this);
    _initializerDefineProperty(this, "labelColor", _descriptor4, this);
    _initializerDefineProperty(this, "isTaxable", _descriptor5, this);
    _initializerDefineProperty(this, "availableOnline", _descriptor6, this);
    _initializerDefineProperty(this, "availableForPickup", _descriptor7, this);
    _initializerDefineProperty(this, "availableElectronically", _descriptor8, this);
    _initializerDefineProperty(this, "categoryId", _descriptor9, this);
    _initializerDefineProperty(this, "buyerFacingName", _descriptor10, this);
    _initializerDefineProperty(this, "ordinal", _descriptor11, this);
    _initializerDefineProperty(this, "modifierListInfo", _descriptor12, this);
    _initializerDefineProperty(this, "imageUrl", _descriptor13, this);
    _initializerDefineProperty(this, "productType", _descriptor14, this);
    _initializerDefineProperty(this, "skipModifierScreen", _descriptor15, this);
    _initializerDefineProperty(this, "preselectFirstVariation", _descriptor16, this);
    _initializerDefineProperty(this, "itemOptions", _descriptor17, this);
    _initializerDefineProperty(this, "ecomUri", _descriptor18, this);
    _initializerDefineProperty(this, "ecomImageUris", _descriptor19, this);
    _initializerDefineProperty(this, "ecomAvailable", _descriptor20, this);
    _initializerDefineProperty(this, "onlineStoreData", _descriptor21, this);
    _initializerDefineProperty(this, "ecomBuyButtonText", _descriptor22, this);
    _initializerDefineProperty(this, "ecomVisibility", _descriptor23, this);
    _initializerDefineProperty(this, "imageIds", _descriptor24, this);
    _initializerDefineProperty(this, "legacyTaxIds", _descriptor25, this);
    _initializerDefineProperty(this, "sortName", _descriptor26, this);
    _initializerDefineProperty(this, "categories", _descriptor27, this);
    /* @fragment('connect/category/membership')
    declare category?: CategoryMembership; */
    _initializerDefineProperty(this, "reportingCategory", _descriptor28, this);
    _initializerDefineProperty(this, "ecomSeoData", _descriptor29, this);
    _initializerDefineProperty(this, "openGraphData", _descriptor30, this);
    _initializerDefineProperty(this, "descriptionHtml", _descriptor31, this);
    _initializerDefineProperty(this, "descriptionPlaintext", _descriptor32, this);
    _initializerDefineProperty(this, "kitchenName", _descriptor33, this);
    _initializerDefineProperty(this, "channels", _descriptor34, this);
    _initializerDefineProperty(this, "ecomAllowOrderItemQuantities", _descriptor35, this);
    _initializerDefineProperty(this, "ecomOrderItemMaxQuantity", _descriptor36, this);
    _initializerDefineProperty(this, "isArchived", _descriptor37, this);
    _initializerDefineProperty(this, "isAlcoholic", _descriptor38, this);
    _initializerDefineProperty(this, "ageRestrictionId", _descriptor39, this);
    _initializerDefineProperty(this, "requiresSubscriptionToSell", _descriptor40, this);
    _initializerDefineProperty(this, "customShippingBoxId", _descriptor41, this);
    _initializerDefineProperty(this, "foodAndBeverageDetails", _descriptor42, this);
    _initializerDefineProperty(this, "comboTypeDetails", _descriptor43, this);
    _initializerDefineProperty(this, "locationOverrides", _descriptor44, this);
    _initializerDefineProperty(this, "channelIntegrations", _descriptor45, this);
    _initializerDefineProperty(this, "programEligibilities", _descriptor46, this);
  }
  get isAvailableOnline() {
    switch (this.ecomVisibility) {
      case EcomVisibility.UNINDEXED:
      case EcomVisibility.UNAVAILABLE:
        return false;
      case EcomVisibility.HIDDEN:
      case EcomVisibility.VISIBLE:
        return true;
      default:
        return Boolean(this.ecomAvailable);
    }
  }
  set isAvailableOnline(value) {
    this.ecomAvailable = value;
    if (value) {
      if (this.ecomVisibility !== EcomVisibility.VISIBLE) {
        this.ecomVisibility = EcomVisibility.HIDDEN;
      }
    } else {
      this.ecomVisibility = EcomVisibility.UNAVAILABLE;
    }
  }
}, _defineProperty(_class2, "_modelNameForMigration", 'connect/item/data'), _class2), _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "description", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "abbreviation", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "labelColor", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isTaxable", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "availableOnline", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "availableForPickup", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "availableElectronically", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "categoryId", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "buyerFacingName", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "ordinal", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "modifierListInfo", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "imageUrl", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "productType", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "skipModifierScreen", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "preselectFirstVariation", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "itemOptions", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "ecomUri", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "ecomImageUris", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "ecomAvailable", [_dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor21 = _applyDecoratedDescriptor(_class.prototype, "onlineStoreData", [_dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor22 = _applyDecoratedDescriptor(_class.prototype, "ecomBuyButtonText", [_dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor23 = _applyDecoratedDescriptor(_class.prototype, "ecomVisibility", [_dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor24 = _applyDecoratedDescriptor(_class.prototype, "imageIds", [_dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor25 = _applyDecoratedDescriptor(_class.prototype, "legacyTaxIds", [_dec25], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor26 = _applyDecoratedDescriptor(_class.prototype, "sortName", [_dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor27 = _applyDecoratedDescriptor(_class.prototype, "categories", [_dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor28 = _applyDecoratedDescriptor(_class.prototype, "reportingCategory", [_dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor29 = _applyDecoratedDescriptor(_class.prototype, "ecomSeoData", [_dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor30 = _applyDecoratedDescriptor(_class.prototype, "openGraphData", [_dec30], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor31 = _applyDecoratedDescriptor(_class.prototype, "descriptionHtml", [_dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor32 = _applyDecoratedDescriptor(_class.prototype, "descriptionPlaintext", [_dec32], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor33 = _applyDecoratedDescriptor(_class.prototype, "kitchenName", [_dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor34 = _applyDecoratedDescriptor(_class.prototype, "channels", [_dec34], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor35 = _applyDecoratedDescriptor(_class.prototype, "ecomAllowOrderItemQuantities", [_dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor36 = _applyDecoratedDescriptor(_class.prototype, "ecomOrderItemMaxQuantity", [_dec36], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor37 = _applyDecoratedDescriptor(_class.prototype, "isArchived", [_dec37], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor38 = _applyDecoratedDescriptor(_class.prototype, "isAlcoholic", [_dec38], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor39 = _applyDecoratedDescriptor(_class.prototype, "ageRestrictionId", [_dec39], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor40 = _applyDecoratedDescriptor(_class.prototype, "requiresSubscriptionToSell", [_dec40], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor41 = _applyDecoratedDescriptor(_class.prototype, "customShippingBoxId", [_dec41], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor42 = _applyDecoratedDescriptor(_class.prototype, "foodAndBeverageDetails", [_dec42], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor43 = _applyDecoratedDescriptor(_class.prototype, "comboTypeDetails", [_dec43], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor44 = _applyDecoratedDescriptor(_class.prototype, "locationOverrides", [_dec44], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor45 = _applyDecoratedDescriptor(_class.prototype, "channelIntegrations", [_dec45], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor46 = _applyDecoratedDescriptor(_class.prototype, "programEligibilities", [_dec46], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Data as default };